import { Box, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import backbluebtn from "../../../Utils/Images/backbluebtn.png";
import user from "../../../Utils/Images/User.png";
import CustomButton from "../../../Components/Button/CustomButton";
import deletebox from "../../../Utils/Images/deletebox.png";
import userblock from "../../../Utils/Images/user block.png";
import UserDetailsTable from "../../../Components/Table/UserDetailsTable";
import { GetSingleUser } from "../../../APIs/Function/User/GetSingleUser";
import { handleEdituser } from "../../../APIs/Function/User/EditUser";
import userbox from "../../../Utils/Images/Userbox.png";
import BlockModal from "../../../Components/Modal/BlockModal";
import DeleteModal from "../../../Components/Modal/DeleteModal";
import Loader2 from "../../../Components/Loader/Loader2";

const UserDetails = () => {
  const valueArray = [
    { title: "Height(Cm)", count: "183cm" },
    { title: "Weight(Kg)", count: "75kg" },
    { title: "Blood Pressure(hg)", count: "145mhg" },
    { title: "Product Purchased", count: "3" },
  ];
  const [UserDetailsData, setUserDetailsData] = useState([]);
  const [UserDetails, setUserDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [blockOpen, setBlockOpen] = useState(false);
  const [loadinga, setLoadinga] = useState(false);
  const [blockStatus, setBlockStatus] = useState("");
  const [modalID, setModalID] = useState("");
  const [blockModalID, setBlockModalID] = useState("");
  const { id } = useParams();
  const navigate = useNavigate();
  const handleClose = () => {
    setOpen(!open);
  };
  const handleModal = (id) => {
    setModalID(id);
    setOpen(true);
  };
  const handleBlockModal = (id, status) => {
    setBlockModalID(id);
    const newStatus = status === 1 ? -1 : 1;
    setBlockStatus(newStatus);
    setBlockOpen(true);
  };
  const handleBlockClose = () => {
    setBlockOpen(false);
  };

  const handleUserDetails = async () => {
    try {
      setLoading(true);
      let res = await GetSingleUser(id);
      setUserDetails(res.r);
      setUserDetailsData(res.r.purchased_product);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  const handleDelete = async (modalID) => {
    setOpen(false);
    await handleEdituser(modalID, blockStatus);
    setLoadinga(true);
    let res = await GetSingleUser(modalID);
    setLoadinga(false);
    setUserDetails(res.r);
    alert("User Deleted Successfully");
    navigate('/users')
  };
  const handleBlock = async (blockModalID) => {
    setBlockOpen(false);
    await handleEdituser(blockModalID, blockStatus);
    {
      blockStatus != 1
        ? alert("User Blocked Successfully")
        : alert("User Unblocked Successfully");
    }
    setLoadinga(true);
    let res = await GetSingleUser(blockModalID);
    setLoadinga(false);
    setUserDetails(res.r);
  };

  useEffect(() => {
    handleUserDetails();
  }, []);
  console.log(UserDetails);

  // const UserDetailsData = [
  //   { photo: "", product_name: "Allsure", product_price: "$200" },
  //   { photo: "", product_name: "Allsure", product_price: "$200" },
  //   { photo: "", product_name: "Allsure", product_price: "$200" },
  // ];
  return (
    <>
      <Box>
        {loading ? (
          <Box sx={{ mt: "25%" }}>
            <Loader2 />
          </Box>
        ) : (
          <Box>
            {/* header */}
            <Box
              sx={{
                bgcolor: "#31AEF4",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                height: { xs: "50px", md: "70px", lg: "70px" },
                p: "10px",
                boxSizing: "border-box",
              }}
            >
              <Link to={`/users`}>
                <Box
                  sx={{
                    height: { xs: "50px", md: "60px", lg: "60px" },
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <img height={"100%"} src={backbluebtn} alt="back" />
                </Box>
              </Link>
              <Box>
                <Typography
                  sx={{
                    fontFamily: "Open Sans",
                    fontSize: { md: "30px", sm: "20px" },
                    fontWeight: 600,
                    lineHeight: "36px",
                    color: "#FFFFFF",
                  }}
                >
                  User Details
                </Typography>
              </Box>
              <Box></Box>
            </Box>
            <Box
              sx={{
                height: "80vh",
                width: "80%",
                m: "auto",
                mt: "50px",
                display: "flex",
              }}
            >
              <Box sx={{ width: "20%" }}>
                <Box
                  sx={{
                    width: "100%",
                    height: "230px",
                    border: "0.5px solid #BDBDBD",
                    p: 2,
                    boxSizing: "border-box",
                  }}
                >
                  <img
                    width={"100%"}
                    height={"100%"}
                    src={
                      UserDetails.profile_img
                        ? `https://api-qhealth.equitysofttechnologies.com//upload/profile_img/${UserDetails.profile_img}`
                        : user
                    }
                    alt="logo"
                  />
                </Box>
                <Box
                  sx={{
                    background: `linear-gradient(0deg, #FBFBFB, #FBFBFB)`,
                    border: "0.5px solid #BDBDBD",
                    fontFamily: "Open Sans",
                    textAlign: "left",
                    p: 1,
                  }}
                >
                  <Typography sx={{ fontsize: "14px", fontWeight: 300 }}>
                    Full Name
                  </Typography>
                  <Typography sx={{ fontsize: "17px", fontWeight: 600 }}>
                    {UserDetails.full_name}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    background: `linear-gradient(0deg, #FBFBFB, #FBFBFB)`,
                    border: "0.5px solid #BDBDBD",
                    fontFamily: "Open Sans",
                    textAlign: "left",
                    p: 1,
                    boxSizing: "border-box",
                    overflow: "hidden",
                  }}
                >
                  <Typography sx={{ fontsize: "14px", fontWeight: 300 }}>
                    Email Address
                  </Typography>
                  <Tooltip title={UserDetails.email} arrow>
                    <Typography
                      sx={{
                        fontsize: "17px",
                        fontWeight: 600,
                        width: "100%",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {UserDetails.email}
                    </Typography>
                  </Tooltip>
                </Box>
                <Box
                  sx={{
                    background: `linear-gradient(0deg, #FBFBFB, #FBFBFB)`,
                    border: "0.5px solid #BDBDBD",
                    fontFamily: "Open Sans",
                    textAlign: "left",
                    p: 1,
                  }}
                >
                  <Typography sx={{ fontsize: "14px", fontWeight: 300 }}>
                    Mobile Number
                  </Typography>
                  <Typography sx={{ fontsize: "17px", fontWeight: 600 }}>
                    +{UserDetails.phone_no}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    background: `linear-gradient(0deg, #FBFBFB, #FBFBFB)`,
                    border: "0.5px solid #BDBDBD",
                    fontFamily: "Open Sans",
                    textAlign: "left",
                    p: 1,
                  }}
                >
                  <Typography sx={{ fontsize: "14px", fontWeight: 300 }}>
                    User Type
                  </Typography>
                  <CustomButton
                    sx={{
                      width: "60%",
                      m: "auto",
                      bgcolor: UserDetails.type === 2 ? "#CAF1C7" : "#E6E6E6",
                      color: "#000000",
                      fontWeight: 500,
                      "&:hover": {
                        bgcolor:
                          setUserDetails.type === 2 ? "#CAF1C7" : "#E6E6E6",
                      },
                    }}
                  >
                    {UserDetails.type === 1 ? "Basic" : "Premium"}
                  </CustomButton>
                </Box>
                <Box
                  sx={{
                    background: `linear-gradient(0deg, #FBFBFB, #FBFBFB)`,
                    p: 2,
                    border: "0.5px solid #BDBDBD",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      gap: "10px",
                      width: "80%",
                      m: "auto",
                      justifyContent: "left",
                    }}
                  >
                    <Box
                      onClick={() => handleModal(id)}
                      sx={{ width: "40px", height: "40px" }}
                    >
                      <img
                        width={"100%"}
                        height={"100%"}
                        src={deletebox}
                        alt=""
                      />
                    </Box>
                    <Box
                      onClick={() => handleBlockModal(id, UserDetails.status)}
                      sx={{ width: "40px", height: "40px" }}
                    >
                      <img
                        width={"100%"}
                        height={"100%"}
                        src={UserDetails.status == -1 ? userblock : userbox}
                        alt=""
                      />
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{ width: "80%" }}>
                {/* value boxes */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "95%",
                    m: "auto",
                  }}
                >
                  {valueArray.map((e, i) => (
                    <Box
                      key={i}
                      sx={{
                        border: "1px solid #DDDDDD",
                        p: 1,
                        paddingY: 2,
                        width: "23%",
                        height: "90px",
                        boxSizing: "border-box",
                        textAlign: "center",
                      }}
                    >
                      <Box>
                        <Typography
                          noWrap
                          sx={{
                            fontFamily: "Open Sans",
                            fontSize: { xs: "12px", md: "14px" },
                            fontWeight: "400",
                            lineHeight: "18px",
                            textOverflow: "ellipsis",
                            overflow: "auto",
                            alignItems: "center",
                            "&:hover": {
                              overflow: "visible",
                            },
                            textAlign: "center",
                          }}
                        >
                          {e.title}
                        </Typography>
                      </Box>
                      <Typography
                        sx={{
                          fontFamily: "Open Sans",
                          textAlign: "center",
                          fontSize: { xs: "16px", md: "24px" },
                          fontWeight: "600",
                          lineHeight: "24px",
                          mt: "10px",
                        }}
                      >
                        {e.title == "Height(Cm)"
                          ? UserDetails?.height || "No Data"
                          : e.title == "Weight(Kg)"
                          ? UserDetails?.weight || "No Data"
                          : e.title == "Blood Pressure(hg)"
                          ? UserDetails?.b_pressure || "No Data"
                          : UserDetails?.purchased_product?.length}
                      </Typography>
                    </Box>
                  ))}
                </Box>
                {/* head */}
                <Box
                  sx={{
                    textAlign: "left",
                    width: "95%",
                    m: "auto",
                    mt: "20px",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Open Sans",
                      fontWeight: 600,
                      fontsize: "21px",
                    }}
                  >
                    Purchased Product
                  </Typography>
                </Box>
                {/* Table */}
                <Box sx={{ width: "95%", m: "auto", mt: "20px" }}>
                  <UserDetailsTable UserDetailsData={UserDetailsData} />
                </Box>
              </Box>
            </Box>
          </Box>
        )}
      </Box>
      <DeleteModal
        open={open}
        handleDelete={handleDelete}
        modalID={modalID}
        onClose={handleClose}
      />
      <BlockModal
        open={blockOpen}
        handleBlock={handleBlock}
        blockModalID={blockModalID}
        handleBlockClose={handleBlockClose}
        blockStatus={blockStatus}
      />
    </>
  );
};

export default UserDetails;
